import React from "react"
import styled from "styled-components"
import ChatList from "../../interview/components/ChatList"
import Link from "../../common/components/Link"
import { responsive } from "buoy-theme"

const ViewTranscriptLink = styled(Link)`
  text-decoration: none;
`

const LinkWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto 24px;
  ${responsive("max-width", "624px", "560px", "560px", "560px", "560px")};
  ${responsive("padding", "0", "0", "0 32px", "0 32px", "0")};
`

const VisitReview = ({ visit, getTranscript }) => (
  <React.Fragment>
    <ChatList isProfile hideOther isClientConvo />
    {visit.loaded ? null : (
      <LinkWrapper>
        <ViewTranscriptLink onClick={getTranscript}>View chat transcript</ViewTranscriptLink>
      </LinkWrapper>
    )}
  </React.Fragment>
)

class VisitReviewContainer extends React.Component {
  render() {
    return this.props.visit ? <VisitReview {...this.props} /> : <span />
  }
}

export { VisitReviewContainer as default, VisitReview }



// WEBPACK FOOTER //
// ./assets/account/components/VisitReview.js